module.exports = __webpack_public_path__ + "img/CHARLES YATES, ESSEX FINNEY, LINDSAY CHERRY AND MATTHEW WINSTON SR. IN 1999.25db92ae.jpg";